module.exports = __webpack_public_path__ + "images/help/icon-twr31-00ba08a5ba21e3b4d77d4620b19ae971.png";